<template>
  <div class="about">
    <v-alert
      icon="mdi-information"
      colored-border
      border="left"
      class="pa-2 my-2 bg-notif"
      color="warning"
      v-if="[5].includes(kVerval)"
    >
      <template v-if="kVerval === 5">
        Yth. Bapak/Ibu Calon Peserta {{ isKasek ? 'Kepala Sekolah' : 'Fasilitator' }} Sekolah Penggerak,
        <br />
        Mohon melakukan perbaikan sesuai informasi tim Verifikasi sebagai berikut:<br />
        <p class="pa-2 my-2 mr-5 white darken-2 subtitle-2">
          <strong v-html="catatanVerval"></strong>
        </p>
        Anda bisa mengajukan perbaikan maksimal 2x24 jam.
      </template>
      <template v-if="kVerval === 4">
        Yth. Bapak/Ibu Calon Peserta {{ isKasek ? 'Kepala Sekolah' : 'Fasilitator' }} Sekolah Penggerak,
        <br />
        Mohon maaf pendaftaran Anda ditolak dengan alasan sebagai berikut:<br />
        <p class="pa-2 my-2 mr-5 white darken-2 subtitle-2">
          <strong v-html="catatanVerval"></strong>
        </p>
        Anda dinyatakan tidak lulus dalam tahap {{ tahap }} seleksi Peserta
        {{ isKasek ? 'Kepala Sekolah' : 'Fasilitator' }} Sekolah Penggerak. Kami mohon Bapak/Ibu dapat mendaftarkan diri
        kembali pada periode berikutnya.
      </template>
    </v-alert>
    <v-alert
      icon="mdi-information"
      close-text="Tutup"
      colored-border
      border="left"
      dismissible
      type="info"
      :class="isLengkap ? 'sc-notif' : 'bg-notif'"
      :color="isLengkap ? 'green' : 'yellow darken-2'"
    >
      <b>Hai {{ $getDeepObj(profil, 'ptk.data.nama') }}!</b>
      <template v-if="isLengkap">
        Anda <strong>telah melengkapi</strong> data informasi Daftar Riwayat Hidup (CV).
      </template>
      <template v-else>
        Silakan melengkapi informasi yang telah kami sediakan dibawah ini.
      </template>
    </v-alert>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text">Daftar Riwayat Hidup (CV)</h1>
            <div class="subtitle-1 black--text">
              Anda sedang berada di seleksi tahap 1 pendaftaran Program Sekolah Penggerak
            </div>
            Anda memiliki waktu hingga tanggal
            <strong>{{ $localDate(wktTutup) }} pkl. 23.59</strong>
            untuk menyelesaikan pengisian pada data Daftar Riwayat Hidup (CV).<br />
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left px-0">
                      <h3 class="title orange--text">Status</h3>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in items" :key="i">
                    <td class="px-0">
                      <v-row no-gutters class="py-2">
                        <v-col cols="10" md="8">
                          {{ item.title }}
                        </v-col>
                        <v-col cols="2" md="4">
                          <v-icon
                            :color="
                              status[item.status] ? 'success' : contents[item.id]['optional'] ? 'warning' : 'grey'
                            "
                          >
                            {{
                              status[item.status]
                                ? 'mdi-check-circle'
                                : contents[item.id]['optional']
                                ? 'mdi-help-circle'
                                : 'mdi-alert-circle'
                            }}
                          </v-icon>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="mt-5 grey lighten-4 black--text pa-2" style="font-size: 0.8rem; border-radius: 5px">
              <b>Keterangan Status :</b> <br />
              <i class="v-icon notranslate mdi mdi-check-circle theme--light success--text" style="font-size: 1rem" />
              &nbsp;Langkah seleksi sudah selesai<br />
              <i class="v-icon notranslate mdi mdi-help-circle theme--light warning--text" style="font-size: 1rem" />
              &nbsp;Status syarat Opsional, Apabila tidak memiliki maka tidak wajib diisi <br />
              <i
                class="v-icon notranslate mdi mdi-alert-circle theme--light grey--text grey-lighten-2"
                style="font-size: 1rem"
              />
              &nbsp; Wajib diisi dan belum dilengkapi/diselesaikan
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row>
      <v-col cols="12">
        <h1 class="headline py-2 mt-2">
          Daftar Riwayat Pendidikan & Pengalaman
        </h1>
        <v-expansion-panels tile flat v-model="tab">
          <v-expansion-panel v-for="item in items" :key="item.id">
            <v-expansion-panel-header class="px-4 subtitle-1">
              {{ item.title }}
            </v-expansion-panel-header>
            <v-divider></v-divider>
            <v-expansion-panel-content class="px-0">
              <component
                role="guru"
                :ref="`tab-${item.id}`"
                :is="item.component"
                :info="info[item.id]"
                :status="!!status[item.table]"
                :type="item.id"
                :component="item.component"
                :items="
                  item.id === 'dokumen'
                    ? dokumens
                    : $getDeepObj(
                        profil,
                        `psp_profil_${item.status || ''}${item.status === 'komunitas' ? 'es' : 's'}.data`
                      ) || []
                "
                :title="item.title"
                :berkases="$getDeepObj(profil, `psp_profil_berkases.data`) || []"
                :withAction="
                  (!isAjuan && !tutupPendaftaran && isCadangan
                    ? !!['dasar', 'kontak', 'dokumen'].includes(item.id)
                    : true) ||
                    (isAjuan && kVerval === 5 && ['dasar', 'dokumen'].includes(item.id))
                "
                :profil="profil"
                @edit="onEdit"
                @upload="onUpload"
              ></component>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- modal form -->
    <base-modal-full
      ref="modal"
      :autoClose="false"
      generalError
      :title="formulir.title"
      @close="onCloseModal"
      @save="onSave(formulir.type)"
    >
      <component
        labelColor="info"
        ref="formulir"
        role="kasek"
        :title="formulir.title"
        :subtitle="formulir.subtitle"
        :deskripsi="formulir.deskripsi"
        :initValue="formulir.init"
        :masters="Object.assign({}, masters, opsi)"
        :configs="configs[formulir.type]"
        :is="formulir.form"
        :type="items[tab] && items[tab]['id'] === 'dokumen' ? formulir.type : items[tab] && items[tab]['id']"
        :action="formulir.action"
        :kSumber="formulir.k_sumber"
        :items="formulir.items"
        :isAkunPkb="formulir.isAkunPkb"
        :max="formulir.max"
        :format="formulir.format"
        :rules="formulir.rules"
        :detail="formulir.detail"
      >
        <template v-slot:extra v-if="formulir.type === 'rekomendasi'">
          <v-subheader :class="[`px-0 my-3 mb-0 body-2 info--text`]" style="height: 24px">
            Pilih Jenis Surat*
          </v-subheader>
          <v-radio-group v-model="ref_berkas" :mandatory="false" row class="mt-0" hide-details>
            <v-radio label="Atasan" value="ref_atasan"></v-radio>
            <v-radio label="Teman Sejawat" value="ref_teman"></v-radio>
            <v-radio label="Komunitas/Organisasi" value="ref_komunitas"></v-radio>
          </v-radio-group>
        </template>
      </component>
    </base-modal-full>
  </div>
</template>
<script>
import baseMixin from '../base/mixin';
import gtkMixin from './mixin';
import FormInput from '../formulir/Input';
import FormCollection from '../formulir/Collection';
import FormAjar from '../formulir/Ajar';
import FormUnggah from '@components/form/Unggah';
import Daftar from '../base/Daftar';
import Info from '../base/Info';

export default {
  name: 'CvIndex',
  mixins: [baseMixin, gtkMixin],
  components: {
    FormInput,
    FormCollection,
    FormAjar,
    FormUnggah,
    Info,
    Daftar,
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
